export default __webpack_public_path__ + "static/media/portfolio-1.cd309632.jpg";